// extracted by mini-css-extract-plugin
export default {"moreInfoRows":"more-information-module__moreInfoRows___wW4HX","name":"more-information-module__name___fpBzu","text":"more-information-module__text___BV7aN"};